// extracted by mini-css-extract-plugin
module.exports = {"blocked":"n_b","loader":"n_c","parallax":"n_P","parallax__img":"n_Q","parallax__inner":"n_R"};